import { wagmiConfig } from 'utils/wagmi'
import { WagmiConfig } from 'wagmi'

export const WagmiClientProvider = (props) => {
  return <WagmiConfig config={wagmiConfig}>{props.children}</WagmiConfig>
}
